<template lang="pug">
.property-list
  .container-fluid
    .container
      .row.pt-3.pb-1
        .col
          h3 {{ $t('property_list_page.property_list') }} ({{ $t('property_list_page.top') }})
          h1 {{ $t('property_list_page.property_list') }}
        .col.text-right.pt-2
          i.fas.fa-spinner.fa-spin.fa-4x.deleting-property(v-if="loading")
          router-link(
            v-if="!isUserReadOnly"
            to="/properties/add"
            class="btn btn-primary mr-3 px-4 py-0"
          )
            i.fas.fa-plus.mr-2
            span {{ $t('property_list_page.add_property') }}
          button(
            class="btn btn-outline-primary px-4 py-0"
            @click="downloadPropertyList"
          ) {{ $t('property_list_page.download_property_list') }}

  .container-fluid.table-container
    .table-header-background-wrapper
      .table-header-background
    .container
      .row.pt-3
        properties-table(
          @change="updatePropertiesData"
          @deletingProperty="startDeleting"
          @deletedProperty="endDeleting"
        )
</template>

<script>
import { api } from '@/api'
import PropertiesTable from '@/pages/Property/List/table'
import downloadXlsx from '@/mixins/download-xlsx'
import currentUserMixin from '@/mixins/current-user'
import { mapState } from 'vuex'

export default {
  components: {
    PropertiesTable
  },

  mixins: [
    downloadXlsx,
    currentUserMixin
  ],

  data() {
    return {
      query: '',
      loading: false
    }
  },

  computed: {
    ...mapState(['currentUser']),
    
    downloadPropertyListUrl() {
      return '/properties/download'
    }
  },

  methods: {
    downloadPropertyList() {
      this.loading = true
      const params = { search: this.query }

      api.post(this.downloadPropertyListUrl, params, { responseType: 'arraybuffer' }).then(({ data, headers }) => {
        this.loading = false
        this.downloadXlsx(data, 'properties.xlsx', headers['content-type'])
      }).catch(() => {
        this.loading = false
        this.$bvToast.show('error-loading')
      })
    },

    updatePropertiesData(query) {
      this.query = query
    },

    startDeleting() {
      this.loading = true
    },

    endDeleting() {
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.property-list {
  background-color: #fff;
}

h1 {
  color: #3d4a57;
  font-size: 30px;
  font-weight: 700;
}

h3 {
  color: #7c91a7;
  font-size: 11px;
  font-weight: 700;
}

.btn-primary,
.btn-primary:hover,
.btn-primary:focus,
.btn-primary:active {
  background-image: linear-gradient(90deg, rgba(24, 172, 235, 0.98) 0%, #18a4eb 100%);
  border-color: transparent !important;
  border-radius: 4px;
  box-shadow: none;
  font-size: 14px;
  font-weight: 500;
  height: 40px;
  line-height: 38px;
}

.btn-outline-primary,
.btn-outline-primary:hover,
.btn-outline-primary:focus,
.btn-outline-primary:active {
  background: transparent;
  border: 1px solid rgba(0, 156, 234, 0.3);
  border-radius: 4px;
  color: #009cea;
  font-size: 14px;
  height: 40px;
  line-height: 38px;
}

.table-container {
  background: #fcfdfe;
  position: relative;

  .table-header-background-wrapper {
    height: 67px;
    margin: 0 -15px;
    overflow: hidden;
    position: absolute;
    width: 100%;
  }

  .table-header-background {
    background: #fff;
    box-shadow: 0 2px 16px 0 rgba(176, 186, 197, 0.2);
    height: 55px;
  }
}

.deleting-property {
  font-size: 28px;
  margin-right: 40px;
}
</style>
